export function initTreeView(el) {
  const $el = $(el);
  if ($el.data("treeview_inited")) return;
  $el.data("treeview_inited", true);
  const id = $el.attr("data-treeview");
  let set;

  function load() {
    let item = null;
    if (id !== "forget") item = localStorage.getItem("treeview_" + id);
    set = item && new Set(JSON.parse(item));
    if(!set) set = new Set($el.find("li.expanded").map(function() { return $(this).attr("data-treeview"); }).get());
  }

  function store() {
    if (id !== "forget") localStorage.setItem("treeview_" + id, JSON.stringify(Array.from(set)));
  }

  try {
    load(id);
    $el.find("li").each(function() {
      const $this = $(this);
      $this.toggleClass("expanded", set.has($this.attr("data-treeview")));
    });
  } catch (e) {
    console.error(e);
  }

  $el.on("click", ".js-treeview-control", function() {
    const $li = $(this).closest("li");
    $li.toggleClass("expanded");
    try {
      if($li.hasClass("expanded")) set.add($li.attr("data-treeview"));
      else set.delete($li.attr("data-treeview"));
      store(id, set);
    } catch (e) {
      console.error(e);
    }
  });
}

function initAll() {
  $(".js-treeview").each((i, el) => {
    initTreeView(el);
  });
}

$(() => {
  initAll();

  if (window.AJAX) {
    window.AJAX.onUpdate(initAll);
  }
});
